import { request } from '@/api/http';
import type { DeleteImpact, ScrapeRunResult, WizardResult } from '@/api/types';

export const deleteImpactService = {
  subscription: (id: string) => request<DeleteImpact>(`/subscriptions/${id}/delete-impact`),
  search: (id: string) => request<DeleteImpact>(`/searches/${id}/delete-impact`),
  user: (id: string) => request<DeleteImpact>(`/users/${id}/delete-impact`),
  recipient: (id: string) => request<DeleteImpact>(`/recipients/${id}/delete-impact`),
};

export const wizardService = {
  setup: (body: object) =>
    request<WizardResult>('/wizard/setup', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
};

export const scrapeService = {
  runSearch: (id: string) => request<ScrapeRunResult>(`/searches/${id}/run`, { method: 'POST' }),
  runSubscription: (id: string) =>
    request<ScrapeRunResult>(`/subscriptions/${id}/run`, { method: 'POST' }),
  validateSearch: (id: string) =>
    request<{ warnings: string[]; ok: boolean }>(`/searches/${id}/validate`),
};
